import React, {ReactNode, useEffect} from "react";
import {Button, MenuProps} from "antd";
import "./page.css";
import Loader from "../loader/Loader";
import useUserContext from "../../hooks/useUserContext";
import {isDisabled} from "@testing-library/user-event/dist/utils";
import {PageButton} from "./PageButton";
import LongArrowLeft from "../../assets/icons/LongArrowLeft";
import {useNavigate} from "react-router-dom";
import LongArrowRight from "../../assets/icons/LongArrowRight";
import Breadcrumbs, {BreadcrumbProps, BreadcrumbsProps} from "../breadcrumbs/Breadcrumbs";
import BurgerMenu, {BurgerMenuItem} from "../burgerMenu/BurgerMenu";

export interface PageAction {
    label: string;
    action: (params: any) => void;
    isDisabled?: boolean;
    options?: MenuProps;
}

interface PageProps {
    children: ReactNode | ReactNode[];
    title?: string | ReactNode | ReactNode[];
    titleRight?: ReactNode;
    subtitle?: string;
    primaryAction?: PageAction;
    secondaryActions?: PageAction[];
    className?: string;
    headerClassName?: string;
    infiniteLoadingCallback?: () => void;
    isLoadingMore?: boolean;
    isFullyLoaded?: boolean;
    backButton?: boolean;
    breadcrumbs?: BreadcrumbProps[];
    burgerItems?: BurgerMenuItem[];
    pageClassName?: string;
}

const Page = ({
    children,
    title = '',
    titleRight,
    subtitle = '',
    primaryAction,
    secondaryActions,
    className = '',
    headerClassName = '',
    infiniteLoadingCallback,
    isLoadingMore = false,
    isFullyLoaded = true,
    backButton = false,
    breadcrumbs,
    burgerItems,
    pageClassName = '',
}: PageProps) => {

    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop < document.documentElement.offsetHeight*0.95 || isLoadingMore) {
            return;
        }
        infiniteLoadingCallback && infiniteLoadingCallback();
    };

    useEffect(() => {
        if(infiniteLoadingCallback) {
            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
        }
    }, [handleScroll]);

    const onBackClick = () => {
        window.history.back();
    }

    return (
        <div className={`page ${pageClassName}`}>
            {title || subtitle || primaryAction || secondaryActions ? <div className={`header ${headerClassName}`}>
                <div className="page-header-left">
                    <Breadcrumbs breadcrumbs={breadcrumbs} />
                    <div className="page-title">
                        {backButton ? <div className="back-button-container" onClick={onBackClick}><LongArrowLeft width={24} height={24} color="#9e9e9e" /></div> : null} {title}
                    </div>
                    <div className="page-subtitle">
                        {subtitle}
                    </div>
                </div>
                <div className="page-header-right">
                    {titleRight}
                    {secondaryActions ? secondaryActions.map(action => <Button className="page-header-secondary" key={`secondary-action-${action.label}`} type="text" disabled={action.isDisabled} onClick={action.action}>{action.label}</Button>) : null}
                    {primaryAction ? <PageButton action={primaryAction} /> : null}
                    {burgerItems?.length ? <BurgerMenu menuId="page-menu" items={burgerItems} /> : null}
                </div>
            </div> : null}
            <div className={`page-content ${className}`}>
                {children}
            </div>
            {isLoadingMore && !isFullyLoaded ? <Loader /> : <div className="page-spacer" style={{width: '100vw', height: '120px'}} />}
        </div>
    );
}

export default Page;
